import { defineMessages } from 'react-intl';

export default defineMessages({
  stepOne: {
    id: 'coachmarks.Saved.Step.One',
    defaultMessage:
      '<p>Your saved programs are listed on this page. Use this page to consider the ones you’re interested in applying to in more detail.</p><p>You can search and filter your Saved programs, just like on the Search page.</p>',
    description: 'Coachmarks saved step one',
  },
  stepTwoParagraphOne: {
    id: 'coachmarks.Saved.Step.Two.ParagraphOne',
    defaultMessage:
      '<p>You can also view school and program details, like on the Search page. If you decide you’re no longer interested in a program, you can unsave it by tapping or clicking on the star.</p>',
    description: 'Coachmarks saved step two paragraph one',
  },
  stepTwoParagraphOnePK: {
    id: 'coachmarks.Saved.Step.Two.ParagraphOne.PK',
    defaultMessage:
      '<p>You can also view pre-K providers and program details, like on the Search page. If you decide you’re no longer interested in a program, you can unsave it by tapping or clicking on the star.</p>',
    description: 'Coachmarks saved step two paragraph one PK',
  },
  stepTwoParagraphOne3K: {
    id: 'coachmarks.Saved.Step.Two.ParagraphOne.3K',
    defaultMessage:
      '<p>You can also view 3-K providers and program details, like on the Search page. If you decide you’re no longer interested in a program, you can unsave it by tapping or clicking on the star.</p>',
    description: 'Coachmarks saved step two paragraph one 3K',
  },
  stepTwoParagraphOne2K: {
    id: 'coachmarks.Saved.Step.Two.ParagraphOne.2K',
    defaultMessage:
      '<p>You can also view 2-K providers and program details, like on the Search page. If you decide you’re no longer interested in a program, you can unsave it by tapping or clicking on the star.</p>',
    description: 'Coachmarks saved step two paragraph one 2-K',
  },
  stepTwoParagraphTwo: {
    id: 'coachmarks.Saved.Step.Two.ParagraphTwo',
    defaultMessage:
      '<p>Unlike on Search, if you save multiple programs from a single school, each program appears on a separate school card.</p>',
    description: 'Coachmarks saved step two paragraph two',
  },
  stepTwoParagraphTwoPK: {
    id: 'coachmarks.Saved.Step.Two.ParagraphTwo.PK',
    defaultMessage:
      '<p>Unlike on Search, if you save multiple programs from a single provider, each program appears on a separate card.</p>',
    description: 'Coachmarks saved step two paragraph two PK',
  },
  stepThree: {
    id: 'coachmarks.Saved.Step.Three',
    defaultMessage:
      'You can choose to order saved programs with the most recently saved ones at the top or by their distance from your child’s home.',
    description: 'Coachmarks saved step three',
  },
  stepFourParagraphOne: {
    id: 'coachmarks.Saved.Step.Four.ParagraphOne',
    defaultMessage:
      '<p>Try saving at least 25 programs! If you’ve saved fewer, you’ll see a reminder above your list.</p>',
    description: 'Coachmarks saved step four paragraph one',
  },
  stepFourParagraphTwo: {
    id: 'coachmarks.Saved.Step.Four.ParagraphTwo',
    defaultMessage:
      '<p>You can return to Search to find more programs to save, and then back to Saved to view just the ones you’re considering.</p>',
    description: 'Coachmarks saved step four paragraph two',
  },
});
